import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthGuard } from './auth/auth.guard';

import { IndexComponent } from './components/Pages/Index/index.component';
import { ErrorComponent } from './components/Pages/Error/error.component';

/* routes: Contiene el mapa de rutas para acceder a los diferentes módulos,
  path: Nombre con el que se accederá a la ruta
  component: Nombre del componente (clase) que contiene la información que se presentará en la vista
  canActivate: Nombre del método que evaluará los permisos por cada ruta
  data: ↓
    token: Contiene el identificador de la página con el que se verificará si el usuario tiene acceso a dicho módulo
    actions: Array de usuarios con permisos adicionales dentro del módulo
*/
const routes: Routes = [
  { path: "Indicators", loadChildren: () => import('./components/Pages/Indicators/indicators.module').then(m => m.IndicatorsModule) },
  { path: "Management", loadChildren: () => import('./components/Pages/Management/management.module').then(m => m.ManagementModule) },
  { path: "Entities", loadChildren: () => import('./components/Pages/Entities/entities.module').then(m => m.EntitiesModule) },
  { path: "Reports", loadChildren: () => import('./components/Pages/Reports/reports.module').then(m => m.ReportsModule) },
  { path: "Error", component: ErrorComponent, canActivate: [AuthGuard], data: { token: '59' } },
  { path: "Home", component: IndexComponent, canActivate: [AuthGuard], data: { token: '59' } },
  { path: "", component: IndexComponent, canActivate: [AuthGuard], data: { token: '59' } },
  { path: '**', redirectTo: 'Error', canActivate: [AuthGuard], data: { token: '59' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
